export default __webpack_public_path__ + "static/media/55.7a322591.jpg";